import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  Button,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useApiFeedback } from "../../../../app/useApiFeedback";
import CustomModal from "../../../../common/custom/CustomModal";
import MessageResponse from "../../../../common/feedback/messageResponse";
import CircularLoader from "../../../../common/loaders/circularLoader";
import CustomTable from "../../../../common/tables/table";
import { addDeclineReasonDto } from "../../models";
import DeclineReasonForm from "./DeclineReasonForm";
import { selectAdmin } from "../../adminSlice";
import { AllDeclineReasonsThunk, DeleteDeclineReasonThunk } from "../../thunks";

const columns = [
  "#",
  "Reason",
  "Description (This will be used in the email sent out)",
  "Actions",
];

export default function AllDeclineReasons() {
  const [open, setOpen] = useState(false);
  const [openNew, setNewOpen] = useState(false);
  const { feedback, handleApiResponse } = useApiFeedback();
  const dispatch = useAppDispatch();
  const selectAdminAction = useAppSelector(selectAdmin);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [page, setPage] = useState<number>(0);
  const [formLoad, setFormLoad] = useState<addDeclineReasonDto | null>(null);
  const [data, setData] = useState<addDeclineReasonDto[]>(
    [] as addDeclineReasonDto[]
  );
  useEffect(() => {
    if (selectAdminAction.adminApplicantDeclineState.declineReasons) {
      setData(selectAdminAction.adminApplicantDeclineState.declineReasons);
    }
  }, [selectAdminAction.adminApplicantDeclineState.declineReasons]);

  useEffect(() => {
    dispatch(AllDeclineReasonsThunk()).then((resp: any) => {
      handleApiResponse(resp, false);
    });
  }, []);

  const handleDeleteReason = (id: number) => {
    dispatch(DeleteDeclineReasonThunk(id)).then((resp: any) => {
      handleApiResponse(resp, true);
    });
  };

  const createTableRows = () => {
    return (
      <>
        {data
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((record: addDeclineReasonDto, key: React.Key) => {
            return (
              <TableRow key={key}>
                <TableCell>{parseInt(key.toString()) + 1}</TableCell>
                <TableCell>{record.reason}</TableCell>
                <TableCell>{record.description}</TableCell>
                <TableCell>
                  <Stack direction="row" spacing={2}>
                    <CustomModal
                    maxWidth="md"
                      open={open}
                      onClose={() => setOpen(false)}
                      triggerButton={
                        <IconButton
                          onClick={() => {
                            setFormLoad({
                              description: record.description,
                              id: record.id,
                              reason: record.reason,
                            } as addDeclineReasonDto);
                            setOpen(true);
                          }}
                        >
                          <EditNoteIcon sx={{ color: "#85B825" }} />
                        </IconButton>
                      }
                      title="Edit Decline Reason"
                    >
                      <DeclineReasonForm
                        formLoad={formLoad}
                        setOpen={setOpen}
                      />
                    </CustomModal>

                    <IconButton onClick={() => handleDeleteReason(record.id)}>
                      <DeleteOutlineOutlinedIcon sx={{ color: "red" }} />
                    </IconButton>
                  </Stack>
                </TableCell>
              </TableRow>
            );
          })}
      </>
    );
  };

  return (
    <>
      <CustomModal
        maxWidth="md"
        open={openNew}
        onClose={() => setNewOpen(false)}
        triggerButton={
          <Button variant="contained" onClick={() => {
            setNewOpen(true)
            setFormLoad({
              description: '',
              id: 0,
              reason: '',
            } as addDeclineReasonDto);
          }}>
            New Decline Reason
          </Button>
        }
        title="Decline Reason"
      >
        <DeclineReasonForm formLoad={formLoad} setOpen={setNewOpen} />
      </CustomModal>

      <MessageResponse feedback={feedback} />

      <Typography mt={2} variant="h5" gutterBottom>
        Decline Reasons
      </Typography>

      <CircularLoader
        status={selectAdminAction.adminApplicantDeclineState.status}
      />

      {selectAdminAction.adminApplicantDeclineState.status === "idle" && (
        <CustomTable
          columns={columns}
          data={data}
          rowsPerPage={rowsPerPage}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          rows={() => createTableRows()}
          page={page}
        />
      )}
    </>
  );
}
